import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchInsertCodeVoilation } from "./learningAPI";
import swal from 'sweetalert';
export interface InsertCodeVoilationState {
  insertCodeVoilation: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: InsertCodeVoilationState = {
    insertCodeVoilation: [],
  status: "idle",
};

export const GetInsertCodeVoilation = createAsyncThunk(
  "InsertCodeVoilation/fetchInsertCodeVoilation",
  async (data:any) => {
    const response = await fetchInsertCodeVoilation(data);
    return response;
  }
);

export const InsertCodeVoilationSlice = createSlice({
  name: "InsertCodeVoilation",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetInsertCodeVoilation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetInsertCodeVoilation.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetInsertCodeVoilation.fulfilled, (state, action) => {
        state.status = "idle";
        state.insertCodeVoilation = action.payload;
        swal("Record saved success!",  "success");
      });
  },
});

export const {} = InsertCodeVoilationSlice.actions;

export const selectInsertCodeVoilation = (state: RootState) => {
  return state.InsertCodeVoilation.insertCodeVoilation;
};

export default InsertCodeVoilationSlice.reducer;
